// extracted by mini-css-extract-plugin
export var contrastLow = "_e-1";
export var externalLink = "_e-2";
export var externalLinkIcon = "_e-3";
export var link = "_e-0";
export var linkLabel = "_e-4";